import React from "react";
import { Info } from "lucide-react";

// Questions CASS has already answered on the visitor's behalf, said out loud in
// the place the question would have been.
export default function FixedAnswerNotes({ notes = [], testId = "pricing-fixed-notes" }) {
  if (notes.length === 0) return null;
  return (
    <div className="space-y-2.5" data-testid={testId}>
      {notes.map((n) => (
        <p
          key={n.key}
          data-testid={`pricing-fixed-note-${n.key}`}
          className="flex items-start gap-2.5 rounded-xl border border-teal/30 bg-teal/[0.06] p-4 text-xs leading-relaxed text-navy"
        >
          <Info size={14} className="mt-0.5 shrink-0 text-teal" />
          {n.message}
        </p>
      ))}
    </div>
  );
}
